export const version = "wallet/5.4.0";
